import { createSlice } from '@reduxjs/toolkit';

import { UserTier } from '@/entities/permissions';
import type { TimeDifference } from '@/utils/getTimeDifference';

import type { PayloadAction } from '@reduxjs/toolkit';

type UserState = {
  isExpired: boolean | undefined;
  userTier: UserTier;
  timeToExpire: TimeDifference | undefined;
};

const initialState: UserState = {
  isExpired: undefined,
  userTier: UserTier.Public,
  timeToExpire: undefined
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserPermissions(
      state,
      action: PayloadAction<{
        isExpired: boolean | undefined;
        userTier: UserTier;
        timeToExpire: TimeDifference | undefined;
      }>
    ) {
      state.isExpired = action.payload.isExpired;
      state.userTier = action.payload.userTier;
      state.timeToExpire = action.payload.timeToExpire;
    }
  }
});

export const { setUserPermissions } = userSlice.actions;
export default userSlice.reducer;
